import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, renderSlot as _renderSlot, createCommentVNode as _createCommentVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-daeda18e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "bigger" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "bg-gray-100 !h-[4px] w-[60px] rounded-lg mx-auto" }, null, -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = {
  ref: "headRef",
  class: "w-full"
}
const _hoisted_5 = {
  key: 1,
  class: "py-2 rounded-t-lg"
}
const _hoisted_6 = {
  key: 0,
  class: "px-5"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SheetUtil = _resolveComponent("SheetUtil")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_SheetUtil, {
      class: "z-[9999]",
      visible: _ctx.suVisible,
      "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.suVisible) = $event)),
      onlyHeaderSwipe: true
    }, {
      header: _withCtx(() => [
        _createElementVNode("div", {
          class: "text-center absolute -mt-10",
          style: _normalizeStyle(_ctx.idkWhatItCalledSize)
        }, _hoisted_3, 4),
        _createElementVNode("div", _hoisted_4, [
          (_ctx.addHeader)
            ? _renderSlot(_ctx.$slots, "header", { key: 0 }, undefined, true)
            : (_openBlock(), _createElementBlock("div", _hoisted_5))
        ], 512)
      ]),
      default: _withCtx(() => [
        _createElementVNode("main", null, [
          (_ctx.addPadX)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _renderSlot(_ctx.$slots, "default", {}, undefined, true)
              ]))
            : _renderSlot(_ctx.$slots, "default", { key: 1 }, undefined, true)
        ])
      ]),
      _: 3
    }, 8, ["visible"])
  ]))
}